<template>
  <div>
    
        <vs-card class="cstm_vx_card mb-4" title="Select View">
          <!-- Subject Component -->
          <div slot="header" class="flex fleex-wrap justify-between">
            <h4>Select View</h4>
          </div>

          <vs-row>
            <subject-listing
              @filterSubjectEvent="filterBySubject"
              @SearchCourseEvent="seachOvaralll"
              @filterCourseEvent="filterByCourse"
              @filterSessionEvent="filterBySessionFrequency"
            ></subject-listing>
            <vs-col
              vs-lg="2"
              vs-sm="12"
              vs-xs="12"
              vs-type="flex"
              vs-justify="flex-end"
              class="p-1"
            >
              <vs-button
                type="filled"
                @click="
                  $router
                    .push({
                      name: 'coursebuilder',
                      params: {
                        type: 'course',
                        courseApplicationType: courseApplicationType,
                      },
                    })
                    .catch(() => {})
                "
                v-if="checkingCreatePermission()"
                >Create</vs-button
              >
            </vs-col>
          </vs-row>
          <!-- Subject Component -->
        </vs-card>

        <vs-card class="cstm_vx_card mb-4">
          <div class="flex flex-wrap justify-between items-center mb-4">
            <h4>All Courses</h4>
            <div class="inline-flex flex-wrap justify-between items-center">
              <!-- <v-select
                style="width: 200px;"
                label="name"
                placeholder="Select"
              >
              </v-select> -->
              <div class="flex items-center icon_holder ml-2">
                <vs-tooltip color="primary" position="top" text="Table View">
                  <span
                    class="material-icons-outlined"
                    :class="[table ? 'active' : '']"
                    @click="viewTab('table')"
                    >table_view</span
                  >
                </vs-tooltip>
                <vs-tooltip color="primary" position="top" text="Grid View">
                  <span
                    class="material-icons-outlined"
                    :class="[grid ? 'active' : '']"
                    @click="viewTab('grid')"
                    >grid_view</span
                  >
                </vs-tooltip>
                <vs-tooltip color="primary" position="top" text="List View">
                  <span
                    class="material-icons-outlined"
                    :class="[list ? 'active' : '']"
                    @click="viewTab('list')"
                    >format_list_bulleted</span
                  >
                </vs-tooltip>
              </div>
            </div>
          </div>
          <template v-if="table">
            <div>
              <div
                class="text-right"
                v-if="isRowSelected && checkingDeletePermission()"
              >
                <div class="bulk_holder">
                  <a @click="bulkDelete"> Bulk Delete </a>
                </div>
              </div>
              <ag-grid-vue
                @cell-clicked="cellSingleClicked"
                :frameworkComponents="frameworkComponents"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :tooltipMouseTrack="true"
                :gridOptions="gridOptions"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="rowData"
                rowSelection="multiple"
                :enableRtl="$vs.rtl"
                colResizeDefault="true"
                :animateRows="true"
                :floatingFilter="false"
                :pagination="true"
                :paginationPageSize="paginationPageSize"
                :style="{ minHeight: rowData.length * 48 + 75 + 'px' }"
                :suppressPaginationPanel="true"
                @grid-ready="onGridReady"
                @row-selected="CellvalueSelectDeselect"
                @sortChanged="sortFun"
              >
              </ag-grid-vue>
              <!-- <div class="flex justify-between items-center">
            <ItemsPerTableDropdown
              tableName="course_table"
              @change="(pageLimit) => pageLimitSet = pageLimit"
            />

        <pagination
              style="float: right"
              :meta="meta"
              @page-change="handlePageChange"
            />
        </div> -->
            </div>
            <vs-popup
              title="Please Confirm"
              :active.sync="deleteHomeworkpopupflag"
            >
              <vs-row>
                <span>Are you sure to delete this Course?</span>
              </vs-row>
              <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
                <vs-button
                  id="delete_status_id"
                  color="primary"
                  type="filled"
                  class="mr-2 vs-con-loading__container"
                  >Confirm</vs-button
                >
                <vs-button
                  @click="deleteHomeworkpopupflag = !deleteHomeworkpopupflag"
                  type="border"
                  >Cancel</vs-button
                >
              </vs-row>
            </vs-popup>
          </template>

          <div class="flex justify-between items-center mt-4">
            <ItemsPerTableDropdown
              tableName="course_table"
              @change="(pageLimit) => (pageLimitSet = pageLimit)"
            />

            <pagination
              style="float: right"
              :meta="meta"
              @page-change="handlePageChange"
            />
          </div>
        </vs-card>

    <vs-card v-if="grid || list">
      <div :class="[list ? 'list_view_holder' : 'grid_view_holder']">
        <div
          class="each_card"
          v-for="(eachData, index) in rowData"
          :key="index"
        >
          <div
            class="relative img_status cursor-pointer"
            @click="openEditView(eachData)"
          >
            <img
              v-if="Object.keys(eachData.courseImage).length > 0"
              :src="eachData.courseImage.file_path"
            />
            <img
              v-else
              src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/Students+watching+webinar+on+computer.jpg"
              alt="course_image"
            />
            <div class="course_status">
              <span class="material-icons-outlined">location_city</span>
              {{
                eachData.delivery_location_id != null
                  ? getDeliverylocation(eachData.delivery_location_id)
                  : ""
              }}
            </div>
          </div>
          <div class="content">
            <div
              class="inline-flex flex-wrap justify-between items-start w-full"
            >
              <div class="w-3/4 mb-4">
                <h5
                  style="max-width: 90%"
                  class="one_line_truncate mb-2 cursor-pointer"
                  @click="openEditView(eachData)"
                >
                  {{ eachData.name }}
                </h5>
                <p
                  class="w-full"
                  :class="[!eachData.readMore ? 'two_lines_truncate' : '']"
                >
                  {{ eachData.description || "No Description" }}
                </p>
                <!-- <a
                  v-if="eachData.shouldShowreadMore"
                  style="white-space: nowrap; cursor: pointer"
                  class="inline-block"
                  @click="readingMore(index)"
                >
                  <span v-if="!eachData.readMore">Read More</span>
                  <span style="color: red" v-else>Show Less</span>
                </a> -->
              </div>
              <div class="inline-flex items-center">
                <vs-switch
                  class="vs-switch-success"
                  @click="
                    ChangeStatus(eachData.status, eachData.id, index, 'Course')
                  "
                  v-model="eachData.status"
                />
                <vs-dropdown
                  style="cursor: pointer"
                  vs-custom-content
                  vs-trigger-click
                >
                  <vs-button
                    color="primary"
                    type="flat"
                    icon-pack="feather"
                    icon="icon-more-vertical"
                  ></vs-button>

                  <vs-dropdown-menu style="min-width: 100px">
                    <vs-dropdown-item @click="coursePreviewNewTab(eachData.id)"
                      >View</vs-dropdown-item
                    >
                    <vs-dropdown-item @click="cloneCourse(eachData.id)"
                      >Clone</vs-dropdown-item
                    >
                    <vs-dropdown-item @click="openEditView(eachData)"
                      >Edit</vs-dropdown-item
                    >
                    <vs-dropdown-item
                      @click="
                        openConfirm(eachData.id, eachData, 'single', 'Course')
                      "
                      >Delete</vs-dropdown-item
                    >
                    <vs-dropdown-item @click="awardCertificate(eachData)">Award Certificate</vs-dropdown-item>
                    <vs-dropdown-item
                      v-if="
                        checkEnrollPermission() &&
                        courseApplicationType == 'General'
                      "
                      @click="enrolledUser(eachData.id, eachData.tutors)"
                      >Teachers</vs-dropdown-item
                    >
                    <vs-dropdown-item
                      v-if="eachData.status"
                      @click="openEnrollmentPopup(eachData.id, eachData)"
                      >Enrol Student</vs-dropdown-item
                    >
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <p>
              Subject:
              {{
                eachData.has_all_subject
                  ? "General"
                  : getDSubjects(eachData.subjects)
              }}
            </p>
            <p>
              Class Type:{{ getCourseTypeName(eachData.course_class_type) }}
            </p>
            <div class="inline-flex flex-wrap justify-between mt-4 w-full">
              <p class="money_holder">£{{ eachData.total_price }}</p>
              <div class="flex items-center">
                <div
                  class="cstm-img-holder"
                  v-for="(tutor, index) in eachData.tutors"
                  :key="index"
                >
                  <vs-tooltip
                    :text="`${tutor.first_name} ${tutor.last_name}`"
                    position="top"
                    color="primary"
                  >
                    <img
                      v-if="tutor.picture != ''"
                      @click="enrolledUser(eachData.id, eachData.tutors)"
                      data-v-b18e1656=""
                      :src="tutor.picture"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <img
                      v-else
                      @click="enrolledUser(eachData.id, eachData.tutors)"
                      data-v-b18e1656=""
                      src="@/assets/images/pages/user-circle-solid.svg"
                      alt="user-img"
                      width="20"
                      height="20"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                  </vs-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="rowData.length==0" class="text-center">No Courses found</div>
      </div>
    </vs-card>

    <div v-if="sharePopUp">
      <vs-popup class="holamundo" title="Staff List" :active.sync="sharePopUp">
        <user-info-modal
          :courseId="shareCourseId"
          Modaltype="Course"
          :sharedUserList="sharedUserList"
          @updateUserId="updateUserId"
        ></user-info-modal>
      </vs-popup>
    </div>

    <div v-if="enrolledUserPopUp">
      <vs-popup
        class="holamundo"
        title="Enrolled Teachers"
        :active.sync="enrolledUserPopUp"
      >
        <enrolled-user-info-modal
          :courseId="shareCourseId"
          Modaltype="Course"
          :sharedEnrolledUser="sharedEnrolledUser"
          @fetchTeacher="fetchTeacher"
        ></enrolled-user-info-modal>
      </vs-popup>
    </div>

    <!-- Student Pop up-->
    <div v-if="studentEnrolledPopUp">
      <vs-popup
        class="holamundo"
        title="Enrolled Students"
        :active.sync="studentEnrolledPopUp"
      >
        <student-enrolled-modal :studentsEnrolledData="studentsEnrolledData">
        </student-enrolled-modal>
      </vs-popup>
    </div>

    <div v-if="certificate_template_modal">
      <vs-popup
        class="holamundo"
        title="Share"
        :active.sync="certificate_template_modal"
      >
        <span v-if="sharedClient.length > 0">
          <h6 class="mb-2">Already Shared With :</h6>
          <div class="flex flex-wrap mb-4">
            <div
              class="text-center mr-1"
              v-for="(selectedUser, index15) in sharedClient"
              :key="index15"
            >
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}}</p> -->
                <img
                  v-if="selectedUser.picture !== null"
                  class="person-img rounded-full shadow-md block"
                  :src="selectedUser.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
        </span>
        <span v-if="sharedStaff.length != 0">
          <div class="flex flex-wrap mb-4">
            <div
              class="text-center mr-1"
              v-for="(selectedUser, index15) in sharedStaff"
              :key="index15"
            >
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}}</p> -->
                <img
                  v-if="selectedUser.picture !== null"
                  class="person-img rounded-full shadow-md block"
                  :src="selectedUser.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
        </span>
        <span
          v-if="selectedStaffs.length != 0 && selectedStaffs.length != null"
        >
          <h6 class="mb-4">Shared Staffs :</h6>
          <div class="flex flex-wrap mb-4">
            <div
              class="text-center mr-1"
              v-for="(selectedUser, index1) in selectedStaffs"
              :key="index1"
            >
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->

                <img
                  v-if="selectedUser.user.picture != ''"
                  class="person-img rounded-full"
                  :src="selectedUser.user.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />

                <span @click="closeSelectedUser1(index1)" class="close"
                  >&times;</span
                >
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
          <vs-divider />
        </span>

        <!-- shared with students name -->

        <span v-if="selectedStudents.length != 0">
          <h6 class="mb-4">Shared Students :</h6>
          <div class="flex flex-wrap mb-4">
            <div
              class="text-center mr-1"
              v-for="(selectedUser, index2) in selectedStudents"
              :key="index2"
            >
              <div class="selected-names">
                <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
                <img
                  v-if="selectedUser.client_user.picture"
                  class="person-img rounded-full"
                  :src="selectedUser.client_user.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                <span @click="closeSelectedUser2(index2)" class="close"
                  >&times;</span
                >
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
          <vs-divider />
        </span>
        <vs-tabs>
          <vs-tab label="Staffs">
            <vs-table
              v-if="stafflist"
              class="checkbox_removed_vstable cstm_vuexy_table"
              multiple
              v-model="selectedStaffs"
              :data="stafflist"
            >
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td style="width: 40px" :data="data[indextr].user.picture">
                    <img
                      v-if="data[indextr].user.picture"
                      class="person-img rounded-full shadow-md block"
                      :src="data[indextr].user.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full shadow-md block"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                  </vs-td>
                  <vs-td>
                    <span>
                      {{ data[indextr].user.first_name }}
                      {{ data[indextr].user.last_name }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div class="flex flex-wrap justify-between items-center my-4">
              <div>
                <vs-button
                  v-if="currentPageUser > 1"
                  @click="showBackUser"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-chevron-left"
                ></vs-button>
              </div>
              <div class="text-right">
                <vs-button
                  icon-pack="feather"
                  icon="icon-chevron-right"
                  v-if="showButtonUser == true"
                  @click="showMoreUser"
                ></vs-button>
              </div>
            </div>
          </vs-tab>

          <vs-tab label="Students">
            <vs-table
              v-if="studentsList"
              class="checkbox_removed_vstable cstm_vuexy_table"
              multiple
              v-model="selectedStudents"
              :data="studentsList"
            >
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td
                    style="width: 40px"
                    :data="data[indextr].client_user.picture"
                  >
                    <img
                      v-if="data[indextr].client_user.picture"
                      class="person-img rounded-full shadow-md block"
                      :src="data[indextr].client_user.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full shadow-md block"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                  </vs-td>
                  <vs-td>
                    <span>
                      {{ data[indextr].client_user.first_name }}
                      {{ data[indextr].client_user.last_name }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <div class="flex flex-wrap justify-between items-center my-4">
              <div>
                <vs-button
                  v-if="currentPageClient > 1"
                  @click="showBackClient"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-chevron-left"
                ></vs-button>
              </div>
              <div class="text-right">
                <vs-button
                  icon-pack="feather"
                  icon="icon-chevron-right"
                  v-if="showButtonClient == true"
                  @click="showMoreClient"
                ></vs-button>
              </div>
            </div>
          </vs-tab>
          <vs-row>
            <div class="text-right mt-4">
              <vs-button
                class="block ml-auto mr-2 mt-4"
                @click="saveAndGenerate('share')"
                >Generate & Share</vs-button
              >
            </div>
            <div class="text-right mt-4">
              <vs-button
                class="block ml-auto mt-4"
                @click="saveAndGenerate('save')"
                >Generate & Save</vs-button
              >
            </div>
          </vs-row>
        </vs-tabs>
      </vs-popup>
    </div>

    <vs-popup title="Warning" :active.sync="additionalPopUp">
      <h3>
        One or more courses could not be deleted as they are referred somewhere
        else.
      </h3>
      <vs-list>
        <vs-list-item
          v-for="(item, index) in nonDeletableItems"
          :key="index"
          :title="item"
        ></vs-list-item>
      </vs-list>
    </vs-popup>
    <div v-if="enrollmentModal">
      <vs-popup
          fullscreen
          classContent="popup-example"
          title="Enrol Student"
          :active.sync="enrollmentModal">
        <Enrollment :course_id="course_id"
        :detailsCourse="courseDetails"
        @enrollmentComplete="enrollmentComplete" />
      </vs-popup>
    </div>
    <!-- Student Pop Up-->
  </div>
</template>

<script>

import Enrollment from '@/views/pages/v1/admission/newEnrollment.vue'
import { cloneCourse, getCourseScheduleSetting } from '@/api/courseBuilder.js'
import courseTag from './courseTag.vue'
import CustomTooltip from './customTooltipVue.js'
import CourseSubjectComponent from './courseSubjectComponent.vue'
import CellRendererCourseAction from './CellRendererCourseAction.vue'
import CellActiveRender from './CellActiveRender.vue'
import { AgGridVue } from 'ag-grid-vue'
import Vue from 'vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

import { blog } from '../../../post-blogs/mixins/blog'
import vSelect from 'vue-select'
import { saveGenerateApi, shareCertificate} from '@/api/certificate'
import { newcourseListing } from '@/api/course-builderapi'
import subjectListing from '@/views/pages/v1/lesson/subjectListing.vue'
import { mapGetters, mapActions } from 'vuex'
import { Tag } from '@/mixins/tag/tag'

import { StatusMixin } from '../../mixins/StatusMixin'
import { DeleteMixin } from '../../mixins/DeletingMixins'

import { PaginationData } from '@/mixins/pagination'

import Pagination from '@/components/common/pagination'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

import userInfoModal from '@/components/assignmentList/userInfoModal.vue'
import EnrolledUserInfoModal from '../../components/EnrolledUserInfoModal.vue'
import StudentEnrolledModal from '../../components/StudentEnrolledModal.vue'

export default {
  components: {
    vSelect,
    subjectListing,
    Pagination,
    userInfoModal,
    EnrolledUserInfoModal,
    StudentEnrolledModal,
    AgGridVue,
    CourseSubjectComponent,
    CustomTooltip,
    courseTag,
    Enrollment
  },
  mixins: [
    StatusMixin,
    DeleteMixin,
    blog,
    Tag,
    PaginationData,
    PermissionMiddleware
  ],

  computed: {
    ...mapGetters(['get_homework_subject_id', 'get_course_deleted_id']),
    selectedLength () {
      if (this.selected.length > 1) {
        return true
      }
    }
  },
  watch: {
    get_course_deleted_id () {
      if (this.get_course_deleted_id) {
        const table = this.rowData
        for (const delete_id_itr of this.get_course_deleted_id) {
          for (let i = 0; i < table.length; i++) {
            //
            if (delete_id_itr === table[i].id) {
              table.splice(i, 1)
              // break
            }
          }
        }

        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.rowData = table
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    }
  },
  beforeMount () {
    this.tooltipShowDelay = 0
    this.frameworkComponents = {
      customTooltip: CustomTooltip
    }
    this.columnDefs = [
      {
        headerName: '',
        minWidth: 60,
        maxWidth: 60,
        field: 'isSelected',
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: '#',
        field: 'row_index',
        filter: false,
        minWidth: 100,
        maxWidth: 100,
        sortable:false,
        resizable: true,
        editable: false,
        valueGetter: (params) => ((this.meta.limit * (this.meta.current_page - 1)) + params.node.rowIndex + 1)
      },
      {
        headerName: 'Course Name',
        field: 'name',
        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false
        // comparator: (params) => {}
      },
      {
        headerName: 'Subject',
        field: 'subjects',
        filter: true,
        minWidth: 150,
        maxWidth: 150,
        resizable: true,
        editable: false,
        tooltipField: 'subjects',
        // comparator: (params) => {},
        tooltipComponentParams: { color: '#fff' },
        floatingFilterComponentParams: {
          suppressFilterButton: false
        },
        cellRendererFramework: Vue.extend(CourseSubjectComponent)
      },
      {
        headerName: 'No of Sessions',
        field: 'no_of_sessions',
        filter: true,
        minWidth: 150,
        maxWidth: 150,
        resizable: true,
        editable: false
        // comparator: (params) => {}
      },
      // {
      //   headerName: 'Tags',
      //   field: 'client_user.first_name',
      //   filter: true,
      //   minWidth: 120,
      //   resizable: true,
      //   editable: false,
      //   cellRendererFramework: Vue.extend(courseTag),
      //   cellRendererParams: {type:'courseTag' }
      // },
      {
        headerName: 'Class Type',
        field: 'course_class_type',
        valueGetter: (params) => {
          const getType = this.course_class_type_list.filter((ele) => {
            return ele.value.includes(params.data.course_class_type)
          })
          if (getType.length) return getType[0].name
          return ''
        },
        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false
      },
      {
        headerName: 'Session Frequency',
        field: 'session_frequency_id',
        valueGetter: (params) => {
          if (params.data.session_frequency_id === 1) return 'Daily'
          else if (params.data.session_frequency_id === 2) return 'Weekly'
          else if (params.data.session_frequency_id === 3) return 'Monthly'
          else if (params.data.session_frequency_id === 4) return 'Yearly'
          else return ''
        },
        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false
      },
      {
        headerName: 'Teacher',
        field: 'teacher_count',

        filter: true,
        minWidth: 150,
        resizable: true,
        editable: false,
        onCellClicked: (params) => this.enrolledUser(params.data.id, params.data.tutors)
      },
      {
        headerName: 'Students',
        field: 'student_count',
        filter: true,
        minWidth: 150,
        maxWidth: 150,
        resizable: true,
        editable: false,
        onCellClicked: (params) => this.enrolledStudent(params.data.id, params.data.students)
      },
      {
        headerName: 'Active',
        field: 'active',
        minWidth: 100,
        resizable: true,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(CellActiveRender),
        filterParams: {
          ChangeStatus: this.ChangeStatus
        }
      },
      {
        headerName: 'Actions',
        field: 'actions',
        minWidth: 100,
        maxWidth: 100,
        resizable: true,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(CellRendererCourseAction),
        filterParams: {
          courseApplicationType: this.courseApplicationType,
          openEnrollmentPopup: this.openEnrollmentPopup,
          sharingCourse: this.sharingCourse,
          sharingCertificate: this.sharingCertificate,
          enrolledUser: this.enrolledUser,
          enrolledStudent: this.enrolledStudent,
          fetchCourseList: this.fetchCourseList,
          awardCertificate: this.awardCertificate
        }
      }
    ]
  },

  props: {
    courseApplicationType: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
  },
  data () {
    return {
      course_id:null,
      courseDetails:null,
      enrollmentModal:false,
      activeMore: null,
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      locations: [
        {
          id: 1,
          name: 'At School'
        },
        {
          id: 2,
          name: 'Online'
        },
        {
          id: 3,
          name: 'At Home'
        },
        {
          id: 4,
          name: 'Other'
        }
      ],
      table: true,
      grid: false,
      list: false,
      isRowSelected: false,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      pageLimitSet: 5,
      frameworkComponents: null,
      columnDefs: [],
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true,
        tooltipComponent: 'customTooltip'
      },
      rowData: [],
      search: '',
      certificate_details: null,
      selectedStaffs: [],
      selectedStudents: [],
      course_type: false,
      course_class_type_list: [
        {
          value: 'self_based',
          name: 'Self Paced Course'
        },
        {
          value: 'online_one_2_one',
          name: 'Online Individual Course'
        },
        {
          value: 'online_one_2_many',
          name: 'Online Group Course'
        },
        {
          value: 'offline_one_2_one',
          name: 'In Person Individual Course'
        },
        {
          value: 'offline_one_2_many',
          name: 'In Person Group Course'
        }
      ],
      enrolledUserPopUp: false,
      sharePopUp: false,
      studentEnrolledPopUp: false,
      subject_ids: false,
      platform_module_id: 3,
      listingtype: 'course',
      courseLists: [],
      defaultImage: '',
      tagSearch: [],
      deleteHomeworkpopupflag: false,
      selected: [],
      shareCourseId: null,
      sharedUserList: [],
      sharedEnrolledUser: [],
      studentsEnrolledData: [],
      session_type: false,
      studentsList: [],
      stafflist: [],
      certificate_template_modal: false,
      sharedClient: [],
      sharedStaff: ''
    }
  },
  errorCaptured () {},
  activated () {},
  deactivated () {},
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Course')
    }
    // this.checkingQuery()
    //this.fetchCourseList()
    this.SET_HOMEWORK_SUBJECT_ID(null)
    this.fetchTag(this.platform_module_id)
  },
  methods: {
    async share_certificate (courseDetails) {
      const customer_id = this.$store.getters.customerId
      let payload = []

      try {
        payload = {
          certificate_ids:[courseDetails.certificate_template_id]
        }

        await shareCertificate(payload, customer_id)
        this.$vs.notify({
          title: 'Success',
          text: 'Shared Certificate Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
      } catch (error) {
        //
      }
    },
    async awardCertificate (courseDetails) {
      if (!courseDetails.certificate_award_method_id) {
        return this.$vs.notify({
          title: 'Warning',
          text: 'Choose a certificate method first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 2000
        })
      }
      if (!courseDetails.certificate_template_id) {
        return this.$vs.notify({
          title: 'Warning',
          text: 'Choose a certificate template',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 2000
        })
      }

      this.share_certificate(courseDetails)
    },
    async openEnrollmentPopup (course_id, courseDetails) {
      this.course_id = course_id
      this.courseDetails = courseDetails
      if (['online_one_2_many', 'offline_one_2_many'].includes(courseDetails.course_class_type)) {
        try {
          const {data} = await getCourseScheduleSetting(this.$store.getters.customerId, this.course_id)
          if (data.data.courseScheduleSetting.has_enrollment_deadline) {
            if (new Date(data.data.courseScheduleSetting.enrollment_deadline) < new Date()) {
              this.showSuccessMessage('Error', 'Enrollment deadline is over', 'warning')
            } else this.enrollmentModal = true
          } else this.enrollmentModal = true
        } catch (e) {
          this.showSuccessMessage('Error', 'Try again later', 'danger')
        }
      } else {
        this.enrollmentModal = true
      }
    },
    async enrollmentComplete () {
      this.enrollmentModal = false
    },
    cellSingleClicked (params) {
      if (params.column.colId === 'name') {
        console.log(params.data.id, params.data)
        this.$router.push({
          name: 'course edit',
          params: {
            course_id: params.data.id,
            course_class_type:params.data.course_class_type

          }
        })
      }
    },
    showMore (index) {
      this.activeMore = index
    },
    showLess () {
      this.activeMore = null
    },
    readingMore (index) {
      this.rowData[index].readMore = !this.rowData[index].readMore
      this.rowData = [...this.rowData]
    },
    cloneCourse (id) {
      cloneCourse(this.$store.getters.customerId, id)
        .then((data) => {
          this.$vs.notify({
            title: 'Success',
            text: 'Course cloned successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 2000
          })
          this.fetchCourseList()
        })
        .catch((e) => {
          console.log(e)
        })
    },
    coursePreviewNewTab (id) {
      this.$router.push({
        name: 'course preview',
        params: {
          course_open_type: 'preview',
          course_id: id
        }
      })
    },
    fetchTeacher (dataObj) {
      console.log(dataObj)
      this.sharedEnrolledUser = [...dataObj]
      console.log(this.sharedEnrolledUser)
      this.fetchCourseList()
    },
    getDSubjects (subjects) {
      const subjects_array = subjects.map((e) => {
        if (e.subject_name) {
          return e.subject_name
        }
      })
      return subjects_array.join(', ')
    },
    getcolumnId (field_name) {
      let field_id = field_name

      if (field_id === 'teacher_count') {
        field_id = 'no_of_tutors'
      } else if (field_id === 'platform_module.module_name') {
        field_id = 'module'
      } else if (field_id === 'student_count') {
        field_id = 'no_of_students'
      }
      return field_id
    },
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        console.log()
        if (sortState[0]) {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = this.getcolumnId(sortState[0].colId)
          this.sorting_obj.direction = sortState[0].sort
        } else {
          this.sorting_obj.field_type = ''
          this.sorting_obj.attribute = ''
          this.sorting_obj.direction = ''
        }


        this.fetchCourseList()
      } catch (e) {
        console.log(e)
      }
    },
    openEditView (eachdata) {
      this.$router.push({
        name: 'course edit',
        params: {
          course_class_type:eachdata.course_class_type,
          course_id: eachdata.id
        }
      })
    },
    getDeliverylocation (delivery_location_id) {
      const delivery_location = this.locations.filter(
        (element) => element.id === delivery_location_id
      )
      return delivery_location[0].name
    },
    viewTab (type) {
      if (type === 'table') {
        this.table = true
        this.grid = false
        this.list = false
      } else if (type === 'grid') {
        this.table = false
        this.grid = true
        this.list = false
      } else if (type === 'list') {
        this.table = false
        this.grid = false
        this.list = true
      }
    },
    ...mapActions(['SET_HOMEWORK_SUBJECT_ID']),
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map((node) => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    closeSelectedUser2 (index) {
      this.selectedStudents.splice(index, 1)
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    closeSelectedUser1 (index) {
      this.selectedStaffs.splice(index, 1)
    },
    async saveAndGenerate (type) {
      const clientNuser = []

      if (this.selectedStudents.length > 0) {
        this.selectedStudents = this.selectedStudents.map((ele) => {
          const container = {}
          container.to_user_type = 2
          container.to_user_id = ele.client_user_id
          return container
        })
        clientNuser.push(this.selectedStudents)
      }

      if (this.selectedStaffs.length > 0) {
        this.selectedStaffs = this.selectedStaffs.map((ele) => {
          const container1 = {}
          container1.to_user_type = 1
          container1.to_user_id = ele.id
          return container1
        })
        clientNuser.push(this.selectedStaffs)
      }
      const payload = {
        course_id: this.shareCourseId,
        title: this.certificate_details.title,
        description: this.certificate_details.description,
        content: this.certificate_details.content,
        type: 1,
        is_shared: type === 'share' ? 1 : 0,
        template_id: this.certificate_details.certificate_template_id,
        userArray: clientNuser.flat(2),
        certificate_image_id:
          this.certificate_details.certificate_image_details
            .certificate_image_id
      }
      await saveGenerateApi(
        payload,
        this.$store.getters.customerId
      )
      this.generateCertificatePopup = false
      this.$vs.notify({
        title: 'Success',
        text: `Certificate generated and ${type} successfully`,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 2000
      })

      this.selectedStaffs = null
      this.selectedStudents = null
      this.certificate_template_modal = false
    },
    checkingQuery () {
      if (
        this.$route.query &&
        'page' in this.$route.query &&
        !isNaN(this.$route.query.page)
      ) {
        this.meta.current_page = this.$route.query.page
      } else {
        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.page = 1

        this.$router
          .replace({
            path: '/pages/course-builder/course',
            query: queryPayload
          })
          .catch(() => {})
      }
    },
    filterBySubject (subject_ids) {
      this.tagSearch = []
      if (subject_ids === 0) {
        this.subject_ids = false
      } else {
        this.subject_ids = subject_ids
      }
      this.fetchCourseList()
    },
    seachOvaralll (search) {
      this.search = search
      this.fetchCourseList()
    },
    filterByCourse (course_id) {
      this.course_type = course_id
      this.fetchCourseList()
    },
    filterBySessionFrequency (session_type) {
      this.session_type = session_type
      this.fetchCourseList()
    },
    tagSearchWise () {
      this.subject_ids = false
      this.fetchCourseList()
    },
    async fetchCourseList () {
      try {
        this.$vs.loading({
          text: 'Please Wait  ...'
        })
        const payload = {}

        if (this.$route.params.course_notification_id) {
          payload.id = this.$route.params.course_notification_id
        }

        if (this.subject_ids) {
          payload.subject_ids = [this.subject_ids]
        } else {
          payload.tag_ids = this.tagSearch
        }
        if (this.course_type) {
          payload.course_type = [this.course_type]
        }
        if (this.session_type) {
          payload.session_frequency_id = this.session_type
        }
        if (this.courseApplicationType === 'General') {
          payload.custom = 0
        }

        if (this.courseApplicationType === 'Custom') {
          // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          // payload.user_id = userInfo.id

          payload.custom = 1
        }

        if (this.courseApplicationType === 'Shared') {
          payload.shared_course = true
        }
        payload.search = this.search
        const customer_id = this.$store.getters.customerId
        payload.limit = this.pageLimitSet

        const responeList = await newcourseListing(
          //this.course_type,
          customer_id,
          payload,
          this.query_page.page,
          this.sorting_obj,
          'course_table'
        )

        this.courseLists = responeList.data.data.course
        this.meta = responeList.data.data.meta
        this.rowData = this.courseLists
        this.rowData = this.rowData.map((row, index) => {
          row.readMore = false
          row.shouldShowreadMore =
            row.description && row.description.length > 63
          row.row_index = index + 1
          return row
        })

        this.defaultImage = responeList.data.data.default_course_image
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    handlePageChange (page) {
      //
      /* const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page
      queryPayload.limit = 10 */
      this.query_page.page = page || 1
      /* const pageScroll = document.documentElement.scrollTop
      this.$router
        .replace({
          path: '/pages/course-builder/course',
          query: queryPayload
        })
        .catch(() => {}).then(() => {
          document.documentElement.scrollTop = pageScroll
        }) */

      setTimeout(() => {
        const queryPayload = Object.assign({}, this.$route.query)
        // queryPayload.tag_ids = tags
        queryPayload.page = page
        queryPayload.limit = this.pageLimitSet
        // queryPayload.search = this.search
        queryPayload.customerId = this.$store.getters.customerId

        const pageScroll = document.documentElement.scrollTop
        this.$router
          .replace({
            path: '/pages/course-builder/course',
            query: queryPayload
          })
          .catch(() => {})
          .then(() => {
            document.documentElement.scrollTop = pageScroll
          })
        this.fetchCourseList()
      }, 0)
    },
    sharingCertificate (data) {
      console.log(data)
      if (data.courseCertificateTemplate) {
        if (data.courseSetting.certificate_share_type === 1) {
          //  let studentdata=[]
          this.certificate_details = data.courseCertificateTemplate
          this.shareCourseId = data.id
          //this.studentsList = data.students
          this.sharedStaff =
            data.courseCertificateTemplate !== null
              ? data.courseCertificateTemplate.shared_user
              : []
          this.sharedClient =
            data.courseCertificateTemplate !== null
              ? data.courseCertificateTemplate.shared_client_user
              : []
          // this.stafflist = data.enrolledUsers
          this.certificate_template_modal = true

          if (data.courseCertificateTemplate !== null) {
            if (this.sharedStaff.length > 0) {
              this.stafflist = data.enrolledUsers
              this.sharedStaff.forEach((element) => {
                this.stafflist = this.stafflist.filter(
                  (item) => item.id !== element.id
                )
              })
            } else {
              this.stafflist = data.enrolledUsers
            }
          }
          if (data.courseCertificateTemplate !== null) {
            if (this.sharedClient.length > 0) {
              this.studentsList = data.students
              this.sharedClient.forEach((element) => {
                this.studentsList = this.studentsList.filter(
                  (item) => item.client_user.id !== element.id
                )
              })
            } else {
              this.studentsList = data.students
            }
          }
        } else {
          this.showSuccessMessage(
            'Error',
            'This course is already shared',
            'danger'
          )
        }
      } else {
        this.showSuccessMessage(
          'Error',
          'Please choose a certificate template',
          'danger'
        )
      }
    },
    sharingCourse (courseId, sharedUserList, courseType) {
      // console.log(courseType)
      if (courseType === 'self_based') {
        this.showSuccessMessage(
          'Error',
          'Self paced course is not Shareable',
          'danger'
        )
      } else {
        this.shareCourseId = courseId
        this.sharedUserList = sharedUserList
        this.sharePopUp = true
      }
    },
    enrolledUser (courseId, enrolledUser) {
      this.shareCourseId = courseId
      this.sharedEnrolledUser = enrolledUser
      this.enrolledUserPopUp = true
    },
    enrolledStudent (courseId, enrolledUser) {
      this.studentsEnrolledData = enrolledUser
      this.studentEnrolledPopUp = true
    },
    updateUserId (userId) {
      const index = this.courseLists.findIndex(
        (element) => element.id === this.shareCourseId
      )

      //   sharedUserList": [
      // {
      //   "to_user_id": 229
      // },
      const to_user_id = userId.map((eachUser) => {
        return {
          to_user_id: eachUser
        }
      })
      this.courseLists[index].sharedUserList = to_user_id
    },
    checkingCreatePermission () {
      if (
        (this.checkCreatePermission() &&
          this.courseApplicationType === 'General') ||
        (this.customCreateAction && this.courseApplicationType === 'Custom')
      ) {
        return true
      } else {
        return false
      }
    },
    checkingEditPermission () {
      if (
        (this.checkEditPermission() &&
          this.courseApplicationType === 'General') ||
        (this.customEditAction && this.courseApplicationType === 'Custom') ||
        this.courseApplicationType === 'Shared'
      ) {
        return true
      } else {
        return false
      }
    },
    checkingDeletePermission () {
      if (
        (this.checkDeletePermission() &&
          this.courseApplicationType === 'General') ||
        (this.customDeleteAction && this.courseApplicationType === 'Custom')
      ) {
        return true
      } else {
        return false
      }
    },

    getCourseTypeName (type) {
      const getType = this.course_class_type_list.filter((ele) => {
        return ele.value.includes(type)
      })
      if (getType.length) return getType[0].name
      return ''
    },
    getCourseSessionName (typeId) {
      let courseTypeName = ''

      switch (typeId) {
      case 1:
        courseTypeName = 'Daily'
        break
      case 2:
        courseTypeName = 'Weekly'
        break
      case 4:
        courseTypeName = 'Monthly'
        break
      default:
        courseTypeName = 'One Time'
      }
      return courseTypeName
    }

    // checkingEditPermission () {
    //   if ((this.checkCreatePermission() && this.courseApplicationType === 'General') || (this.customCreateAction && this.courseApplicationType === 'Custom')) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }
  }
}
</script>

<style scoped>
.cstm_list_card .scrollable-container {
  max-height: calc(100vh - 110px);
}
</style>
